import React from 'react';
import { userService } from '../../_services';
import { connect } from 'react-redux';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/flip.css';

class RegisterPage extends React.Component
{
    constructor(props){
        super(props); 

        this.state = {
            email : '' , 
            name : '' , 
            password : '' , 
            confirmpassword : '' ,
            mobileNumber : '' , 
            isAccept : false , 
            disableSubmit : false 
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event){
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        this.setState ({
            [event.target.name] : value  //update state of corresponding input name 
        })
    }

    handleSubmit(event){
        event.preventDefault();
        
        if(this.state.password != this.state.confirmpassword){
            
            Alert.error("Password and Confirm password does not match", {
                position: 'bottom-right' , 
                effect : 'flip'
            });

            return false;
        }

        if(!this.state.isAccept){
            
            Alert.error("Please accept User Agreement and Privacy Policy before registering", {
                position: 'bottom-right' , 
                effect : 'flip'
            });

            return false;
        }

        this.setState({
            disableSubmit : true
        });

        userService.register(this.state);
    }

    render(){
        let {email , password , confirmpassword , name , mobileNumber ,  isAccept } = this.state;

        const disableSubmit = this.state.disableSubmit ? 'disabled' : '' ; 

        return (
            <div>
                <div className="columns">
                    <div className="column is-12">
                        <h3 className="title">Create your personal account</h3>
                    </div>
                </div>
                
                <form onSubmit={this.handleSubmit}>
                    <div className="field">
                        <div className="control m-t-md">
                            <div className="control-label">Email Address</div>
                            <input className="input" name="email" type="email" value={email} placeholder="" onChange={this.handleChange} 
                                required
                            />
                        </div>
                        <div className="control m-t-md">
                            <div className="control-label">Full Name</div>
                            <input className="input" name="name" type="textbox" value={name} placeholder="" onChange={this.handleChange} 
                                required
                            />
                        </div>
                        <div className="control m-t-md">
                            <div className="control-label">Password</div>
                            <input className="input" name="password" type="password" value={password} placeholder="" onChange={this.handleChange} 
                                required pattern=".{8,}" title="Password has to be 8 characters minimum"
                            />
                        </div>
                        <div className="control m-t-md">
                            <div className="control-label">Confirm Password</div>
                            <input className="input" name="confirmpassword" type="password" value={confirmpassword} placeholder="" onChange={this.handleChange} 
                                required pattern=".{8,}" title="Password has to be 8 characters minimum"
                            />
                        </div>
                        <div className="control m-t-md">
                            <div className="control-label">Mobile Number</div>
                            <input className="input" name="mobileNumber" type="tel" value={mobileNumber} placeholder="ie: 6012345678" onChange={this.handleChange} 
                                required pattern="[0-9]{0,12}" 
                            />
                        </div>
                        <div className="control m-t-md">
                            <input type="checkbox" name="isAccept" checked={isAccept} onChange={this.handleChange}/>
                            <span className="m-l-xs">By creating account , you agree to our <a href="/tnc" target="_blank">User Agreement</a> and <a href="/privacypolicy" target="_blank">Privacy Policy</a></span>
                        </div>
                        <div className="control m-t-lg">
                            <input type="submit" disabled={disableSubmit} className="button button-submit"/>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}


function mapStateToProps(state) {
    const { loading } = state;
    return {
        loading 
    };
}

const connectedRegisterPage = connect(mapStateToProps)(RegisterPage);
export { connectedRegisterPage as RegisterPage }; 



// WEBPACK FOOTER //
// ./src/Views/RegisterPage/RegisterPage.jsx